import { render, staticRenderFns } from "./SelectMediums.vue?vue&type=template&id=f4b7f60a"
import script from "./SelectMediums.vue?vue&type=script&lang=js"
export * from "./SelectMediums.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports